import { BaseService } from "./BaseService";
const config = require("../../config");
import { CognitoUser } from "amazon-cognito-identity-js";
const domusoApiServiceUrl = config.domusoApiService;

export class PropertyService extends BaseService {
  constructor(
    public cognitoUser: CognitoUser,
    public dispatch = (any: any) => {},
    public url = domusoApiServiceUrl
  ) {
    super(url, cognitoUser, dispatch);
  }
  static async searchPublicProperties(name: string) {
    const url = `${config.domusoApiService}/v1/property?name=${name}`;
    const res = await fetch(url);
    const json = await res.json();
    return json;
  }
  static async getPublicPropInfo(code: string) {
    const url = `${domusoApiServiceUrl}/v1/property/${code}`;
    const res = await fetch(url);
    if (res.status === 204) return null;
    const json = await res.json();
    return json;
  }
}
